export default "__VITE_ASSET__da020193__"